<template>
  <el-dialog
    v-model="dialogVisible"
    title="操作确认"
    width="500"
  >
    <div class="draft-btn-group">
      <el-button size="large" :type="!isAuto ? 'primary' : 'default'" @click="handleChangeAuto(false)">逐步生成</el-button>
      <el-button size="large" :type="isAuto ? 'primary' : 'default'" @click="handleChangeAuto(true)">一键生成</el-button>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handleOk">
          确定
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, unref } from "vue"

const dialogVisible = ref(false)
const isAuto = ref(false)
const emits = defineEmits(['ok'])

const open = () => {
  isAuto.value = false
  dialogVisible.value = true
}

const close = () => {
  dialogVisible.value = false
}

const handleOk = () => {
  close()
  emits('ok', unref(isAuto))
}

const handleChangeAuto = (flag) => {
  isAuto.value = flag
}
defineExpose({ open })

</script>

<style lang="scss" scoped>
.draft-btn-group {
  display: flex;
  :deep(.el-button) {
    flex: 1;
  }
}
</style>